import React, { useState } from 'react'

import { PlusOutlined, UploadOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useOperatorNotification } from '@contexts/operator/OperatorNotificationContext'
import { useMerchant } from '@contexts/operator/MerchantContext'
import { useIsStandard } from '@contexts/operator/PlanContext'
import { useOperatorProductService } from '@hooks/operator/products/useOperatorProductService'
import Can from '@shared/permissions/Can'
import brandService from '@services/operator/brandService'
import ListPageHeader from '@shared/ListPageHeader'
import ProductsList from '@shared/products/ProductsList'

const OperatorProductsList: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { addJob } = useOperatorNotification()
  // useMerchant 仍是 .jsx，narrow 到本頁實際使用的欄位。
  const { merchants } = useMerchant() as { merchants: Array<{ id: string; name: string }> }
  const isStandard = useIsStandard() as boolean
  const service = useOperatorProductService()
  const [importModalVisible, setImportModalVisible] = useState(false)

  return (
    <div>
      <ListPageHeader
        items={['products', 'products.list']}
        actions={
          <>
            <Can requiredPermission="products:write">
              <Button
                icon={<UploadOutlined />}
                onClick={() => setImportModalVisible(true)}
              >
                {t('common.button.import')}
              </Button>
            </Can>
            <Can requiredPermission="products:write">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => navigate('/products/new')}
              >
                {t('common.button.new')}
              </Button>
            </Can>
          </>
        }
      />
      <ProductsList
        role="operator"
        service={service}
        brandService={brandService}
        addJob={addJob}
        merchants={merchants}
        importModalVisible={importModalVisible}
        setImportModalVisible={setImportModalVisible}
        hideMerchantUI={isStandard}
      />
    </div>
  )
}

export default OperatorProductsList
